import ViewCoupons from "../components/Coupon/ViewCoupon";

const CouponsPage: React.FC = () => {
  return <ViewCoupons />;
};

export default CouponsPage;
